import { useEffect } from 'react';
import i18n from '@/utils/i18n';
import { useWidgetConfig } from './useWidgetConfig';

export const getMatchedLng = (
  availableLanguages: Record<string, boolean>,
  lng: string,
) => {
  // match language-country code (e.g. zh-HK)
  const matchedLanguageRegion = availableLanguages[lng];
  if (matchedLanguageRegion) {
    return lng;
  }

  // for all unmatched zh langs, fallback to zh-HK if enabled from config
  // zh-CN should not reached here, because if its matched and enabled, the above logic will catch it
  if (lng.split('-')[0] === 'zh') {
    return availableLanguages['zh-HK'] ? 'zh-HK' : false;
  }

  // match language code (e.g. zh)
  const availableLanguageCodes: Record<string, string | false> =
    Object.fromEntries(
      Object.entries(availableLanguages).map(
        ([availableLanguage, available]) => [
          availableLanguage.split('-')[0],
          available ? availableLanguage : false,
        ],
      ),
    );
  const matchedLanguageCode = availableLanguageCodes[lng.split('-')[0]];
  if (matchedLanguageCode) {
    return matchedLanguageCode;
  }
};

export const useLanguageInit = () => {
  const { languageConfig, config } = useWidgetConfig();

  useEffect(() => {
    if (!config) return;

    // Detect Browser Language
    const browserLanguage = navigator.language;
    const matchBrowserLanguage = getMatchedLng(
      languageConfig.availableLanguages,
      browserLanguage,
    );

    if (matchBrowserLanguage) {
      i18n.changeLanguage(matchBrowserLanguage);
      return;
    }

    // Default Language
    i18n.changeLanguage(languageConfig.defaultLanguage);
  }, [languageConfig, config]);
};
